import React, {Component} from "react";

import {request} from "api-client";
import FormViewContainer from "../../../components/Letflow/ViewContainer/FormViewContainer";
import FormContent from "../FormContent";
import localization from "../../../config/localization";
import {TryAgainSnackbar} from "../../../components/Letflow/Snackbar";
import {getUpdateFormImageUrlFromItem, makeUrlWithTableParams} from "../../../utils";

export default class extends Component {

  state = {
    id: '',
    type: '',
    color: '',
    image: { src: null, file: null },
  }


  requestFeaturedImage= () => request.featuredImage.get(this.props.match.params.id).then(featuredImage => {
    this.setState({
      id: featuredImage.id,
      type: featuredImage.type,
      color: featuredImage.color,
      image: {
        src: getUpdateFormImageUrlFromItem(featuredImage),
        file: null,
      },
    })
  })

  requestUpdate = () => {
    const {
      id,
      type,
      color,
      image: {file}
    } = this.state

    const data = {
      id,
      type,
      color,
      image: file,
    }

    return request.featuredImage.update(id, data)
      .then(() => this.props.history.push(makeUrlWithTableParams('/panel/featured_images')))
  }

  onChange = e => this.setState({ [e.target.id]: e.target.value })
  onImageChange = image => this.setState({ image })

  render = () => {
    return (
      <div>
        <FormViewContainer
          title={localization.get('view.featured_image.update')}
          submitRequest={() => this.requestUpdate()}
          onBack={() => this.props.history.goBack()}
          initializationRequest={() => this.requestFeaturedImage()}
          onRequestingStateChanged={value => this.setState({ disabled: value })}
        >
          <FormContent
            type={this.state.type}
            image={this.state.image}
            color={this.state.color}
            onChange={this.onChange}
            onImageChange={this.onImageChange}
          />
        </FormViewContainer>
        <TryAgainSnackbar ref='snackbar' />
      </div>
    )
  }
}
